// extracted by mini-css-extract-plugin
export default {"footer":"UnlimitedDocumentsNote__footer--vTDNf"};